import React from 'react';
import { Collapse } from 'reactstrap';

class SignUpBibsListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isFullCollapsed: false,
    };
  }

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
    const _this = this;
    if (!this.state.collapse) {
      this.setState({ isFullCollapsed: !this.state.isFullCollapsed });
    } else {
      setTimeout(() => {
        _this.setState({ isFullCollapsed: !_this.state.isFullCollapsed });
      }, 390);
    }
  };

  render() {
    const { reference, qual } = this.props;

    let totalQuestionsCount = 0;
    const totalChapters = reference.chapters.length;
    reference.chapters.forEach((chapter) => {
      totalQuestionsCount += Number(chapter.questionCount);
    });

    return (
      <div>
        <div
          className={`bib-item expand-${reference.actAsParent} collapsed-${this.state.isFullCollapsed}`}
          style={{ cursor: qual ? 'default' : 'pointer' }}
          onClick={this.toggle}
        >
          <div className="bib-contents">
            {!qual && (
              <i
                className={
                  this.state.collapse
                    ? `d-flex icon-expand rotate down act-as-parent-${reference.actAsParent}`
                    : `d-flex icon-expand rotate act-as-parent-${reference.actAsParent}`
                }
              />
            )}

            <div className="bib-name">
              {reference.name}
              {reference.description && reference.description !== '' && (
                <span className="bib-description">
                  {` - ${reference.description}`}
                </span>
              )}
            </div>
          </div>
          <div className="question-counters">
            {(totalQuestionsCount > 0 && !qual) ||
            (totalChapters > 0 && qual) ? (
              <div className="count-badge">
                {!qual ? (
                  <div>{`${totalQuestionsCount} Questions`}</div>
                ) : (
                  <div>{`${totalChapters} Chapters`}</div>
                )}
              </div>
            ) : null}
          </div>
        </div>

        {reference.actAsParent && reference.chapters.length > 0 && !qual && (
          <Collapse
            className="collapse-chapters-group"
            isOpen={this.state.collapse}
          >
            {reference.chapters.map((chapter, index) => (
              <div
                className={`chapter-item last-${
                  index === reference.chapters.length - 1
                }`}
                key={`chapter-${chapter.id}`}
              >
                <div className="chapter-contents">
                  <div className="chapter-name">
                    {chapter.name}
                    {chapter.description && chapter.description !== '' && (
                      <span className="chapter-description">
                        {` - ${chapter.description}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="chapter-question-counters">
                  {chapter.questionCount && chapter.questionCount > 0 ? (
                    <div className="chapter-count-badge">
                      {`${chapter.questionCount} Questions`}
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </Collapse>
        )}
      </div>
    );
  }
}

export default SignUpBibsListItem;
